module.exports = __webpack_public_path__ + "static/media/gallery_2_2.005c183c.jpg";